// General
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Grid, Row, Col } from 'react-bootstrap';

import StepHeaderBlock from './StepHeaderBlock';
import { Whitespace, Text } from '../common';
import InputHeader from '../common/FormComponents/InputHeader';
import Input from '../common/FormComponents/InputStyle';
import ListPlaceTips from '../../components/ListPlaceTips/ListPlaceTips';
import FormNav from '../common/FormComponents/FormNav';
import { observer } from 'mobx-react';
import { allowNumericKeysOnly } from './utils';
import DayCalendar from '../../components/DayCalendar/DayCalendar';
import Select from './Select';
import moment from 'moment-timezone';
import { timezones } from './../../helpers/mergeTimes';

const timeZoneOptions = timezones.map(timezone => {
  return (
    <option value={timezone.value} key={timezone.value}>
      {timezone.label}
    </option>
  );
});

@observer
class Availability extends Component {
  static propTypes = {
    store: PropTypes.object,
    nextPage: PropTypes.func,
  };

  onSelected = selection => {
    const { store } = this.props;
    store.blockedDates = selection;
  };

  render() {
    const { store, nextPage } = this.props;

    const visited = store.groupsVisited.availability;

    return (
      <Grid>
        <Row>
          <Col xs={12} sm={7} md={7} lg={7}>
            <StepHeaderBlock headerText="Black out the days your item will be unavailable." />
            <Whitespace smaller />
            <DayCalendar
              disabledDates={store.reservedDates}
              blockedDates={store.blockedDates}
              onChange={this.onSelected}
            />
            <Whitespace smaller />
            {
              // <div className="f-columns f-start-center">
              //   <div>
              //     <InputHeader
              //       label="Return time"
              //       error={(visited && store.fieldErrors('returnTime')) || ''}
              //     />
              //     <Input
              //       onChange={e => (store.returnTime = e.target.value)}
              //       value={store.returnTime}
              //       placeholder="9:00 AM"
              //       type="time"
              //     />
              //   </div>
              //   <div className="ml-m">
              //     <InputHeader
              //       label="Return time zone"
              //       error={
              //         (visited && store.fieldErrors('returnTimeZone')) || ''
              //       }
              //     />
              //     <Select
              //       onChange={e => (store.returnTimeZone = e.target.value)}
              //       value={store.returnTimeZone}
              //     >
              //       {timeZoneOptions}
              //     </Select>
              //   </div>
              // </div>
            }
            <Whitespace small />
            <FormNav nextPage={nextPage} store={store} />
          </Col>
          <Col>
            <ListPlaceTips
              tips={[
                {
                  title: 'Availability',
                  tips: [
                    'Select the days you want to use your rental, we will mark it as available for the rest of the days. These days can always be changed in the future.',
                  ],
                },
                {
                  title: 'Return time',
                  tips: [
                    'The return time is when your renters need to get the item back to you each day.',
                    'This uniform time will make managing your rentals a lot easier so you can get the item back before you rent it out again.',
                  ],
                },
              ]}
            />
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default Availability;



// WEBPACK FOOTER //
// ./src/components_new/addListing/Availability.js